/**
 * @format
 */
import {
   ChangeDetectionStrategy,
   Component,
   Input,
   OnChanges,
   OnDestroy,
   OnInit,
   SimpleChanges,
   ViewEncapsulation,
} from "@angular/core";
import { Subscription } from "rxjs/internal/Subscription";
import { ContenteditableDirective } from "../core/content-editable/contenteditable.directive";
import { BsModalService } from "ngx-bootstrap/modal";
import { TagMappingModalComponent } from "./sms-convertion-ar2-to-ar3/tags-mapping-modal/tag-mapping-modal.component";
import { SmsConversionService } from "./sms-convertion-ar2-to-ar3/sms-conversion.service";
import { Store } from "@ngrx/store";
import { PreviewEditTemplateActions } from "../preview-edit-template/state/preview-edit-template.actions";

@Component({
   selector: "sms-message-new",
   templateUrl: "./sms-message-new.component.html",
   styleUrls: ["./sms-message-new.component.css"],
   changeDetection: ChangeDetectionStrategy.OnPush,
   encapsulation: ViewEncapsulation.None,
})
export class SmsMessageNewComponent implements OnInit, OnChanges, OnDestroy {
   @Input() readonly isOnlyPreview: boolean;
   @Input() updatedModel;
   @Input() templateParameters;
   @Input() contextVariables;
   @Input() userPermissions;
   @Input() communicationsCategoryId;
   @Input() tabIndex;
   @Input() readonly disablePasteEvent: boolean;
   @Input() triggeredCategory;

   selectedTemplateParameter: any;
   selectedNode: any;
   cloneTemplate: any;
   smsText: any;
   maxReached = false;
   smsTextLength = 0;
   cloneContextVariable: any;
   subscription = new Subscription();
   displayTemplateParameters = [];
   selection: any;

   constructor(
      public contenteditableDirective: ContenteditableDirective,
      private modalService: BsModalService,
      private smsConversionService: SmsConversionService,
      private store: Store<any>
   ) {}

   getMessagesByCharacters(): number {
      const charsPerMessage = 160;
      const smsParts =
         this.cloneContextVariable === undefined || this.cloneContextVariable.smsMessage === undefined
            ? 1
            : Math.ceil(this.smsTextLength / charsPerMessage);

      this.store.dispatch(
         PreviewEditTemplateActions.setSmsPartsAndParsedTextLength({
            smsParts,
            smsParsedTextLength: this.smsTextLength,
         })
      );
      this.maxReached = this.smsTextLength > 480;
      return smsParts;
   }

   setSelectedNode(e): void {
      if (e.target.innerHTML === "×") {
         // update the text length on removing template-context
         const innerText = e.target.parentElement.innerText.slice(0, e.target.parentElement.innerText.indexOf(" "));
         const data = this.templateParameters.find((parameter) => parameter.label === innerText);
         if (data !== undefined) {
            this.cloneContextVariable.smsMessage = this.cloneContextVariable.smsMessage.replace(data.dummyValue, "");
         }
         this.maxReached = this.cloneContextVariable.smsMessage.length >= 480;
         this.smsTextLength = this.cloneContextVariable.smsMessage.length;
      } else {
         if (e.target.attributes["contenteditable"] !== undefined) {
            this.selectedNode = e.target;
         }
      }

      // this is needed to enable cursor to  be displayed after template-context when last child
      if (
         this.selectedNode !== undefined &&
         this.selectedNode.lastChild !== undefined &&
         this.selectedNode.lastChild.localName === "template-context"
      ) {
         const textnode = document.createTextNode(""); // Create a text node
         this.selectedNode.appendChild(textnode);
      }
   }

   ngOnInit(): void {
      this.cloneTemplate = { ...this.updatedModel };
      this.smsText = this.cloneTemplate.smsMessage;

      this.subscription.add(
         this.smsConversionService.listenConversion(() => {
            const smsElement = document.getElementById("template.smsMessage");

            const innerHTMLReplaced = this.smsConversionService.replaceAR2TagForAR3InValue(smsElement.innerHTML);

            smsElement.innerHTML = innerHTMLReplaced;

            this.smsConversionService.updateValueOnTemplateModel(innerHTMLReplaced, "smsMessage");
         })
      );
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (changes.updatedModel !== undefined) {
         if (this.updatedModel.smsMessage !== undefined) {
            this.cloneTemplate = { ...this.updatedModel };
         }
      }

      if (changes.tabIndex !== undefined && this.tabIndex === 1) {
         this.smsText = this.cloneTemplate.smsMessage;
      }

      if (changes.contextVariables !== undefined) {
         this.cloneContextVariable = { ...this.contextVariables };
         if (this.smsText === undefined && this.updatedModel.smsMessage !== undefined) {
            this.smsText = this.updatedModel.smsMessage;
         }
         if (this.smsText !== undefined) {
            this.calculateTest(this.smsText);
         }
      }

      if (changes.templateParameters !== undefined || changes.triggeredCategory !== undefined) {
         if (this.templateParameters !== undefined && this.templateParameters.length !== 0) {
            // Implementing displaying Pets in drop down only if User is Vet i.e has permission 'resource:pets'
            // Implementing displaying Pets in drop down only if User is Vet i.e has permission 'resource:pets'
            this.displayTemplateParameters = [...this.templateParameters];
            if (this.triggeredCategory === "orders") {
               const locationIndex = this.displayTemplateParameters.findIndex(
                  (templateParameter) => templateParameter.label === "location"
               );
               this.displayTemplateParameters.splice(locationIndex, 4);
               const appointmentIndex = this.displayTemplateParameters.findIndex(
                  (templateParameter) => templateParameter.label === "appointment time"
               );
               this.displayTemplateParameters.splice(appointmentIndex, 4);
            }
            this.selectedTemplateParameter = this.templateParameters[0].value;
         }
      }
   }

   ngOnDestroy(): void {
      this.subscription.unsubscribe();
      this.smsConversionService.displayButton(false);
   }

   setSelectedData(): void {
      this.selection = {
         focusOffset: window.getSelection().focusOffset,
         focusNode: window.getSelection().focusNode,
      };
   }

   calculateTest(innerHTML): void {
      // in Safari, when contenteditable is empty it adds <br>
      if (innerHTML.length === 0 || innerHTML === "<br>") {
         this.smsTextLength = 0;
      } else if (innerHTML.indexOf("template-context") === -1) {
         this.smsTextLength = innerHTML.length;
      } else {
         this.smsTextLength = this.cloneContextVariable.smsMessage.length;
      }
   }

   openTagMappingModal(): void {
      const modalRef = this.modalService.show(TagMappingModalComponent, {
         backdrop: "static",
         class: "modal-md",
         keyboard: false, // disable esc key
      });
   }
}
